module.exports = __webpack_public_path__ + "0414640c1c0f43c29ee1641cd3bf88ad.svg";